import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { createPortal } from 'react-dom'
import { CSSTransition, TransitionGroup } from 'react-transition-group'

export default class ReactImagesPortal extends Component {
  componentDidMount() {
    this.portalElement = document.createElement('div')
    document.body.appendChild(this.portalElement)
    this.forceUpdate()
  }

  componentWillUnmount() {
    if (!this.portalElement) return
    document.body.removeChild(this.portalElement)
  }

  transitionNodeRef = React.createRef()

  render() {
    if (!this.portalElement) return null

    const duration = 200
    const styles = `
      .fade-enter { opacity: 0.01; }
      .fade-enter.fade-enter-active { opacity: 1; transition: opacity ${duration}ms; }
      .fade-exit { opacity: 1; }
      .fade-exit.fade-exit-active { opacity: 0.01; transition: opacity ${duration}ms; }
    `

    return createPortal(
      <div>
        <style>{styles}</style>
        <TransitionGroup {...this.props}>
          <CSSTransition
            nodeRef={this.transitionNodeRef}
            timeout={{ enter: duration, exit: duration }}
            classNames="fade"
          >
            <div ref={this.transitionNodeRef}>{this.props.children}</div>
          </CSSTransition>
        </TransitionGroup>
      </div>,
      this.portalElement
    )
  }
}

ReactImagesPortal.propTypes = {
  children: PropTypes.node.isRequired,
}
